import { Sequence } from "../audio/Sequence.js";

export interface AudioControlOptions {
    container: HTMLElement;
    sequence: Sequence;
}

export class AudioControl {

    private _element: HTMLElement;
    private _sequence: Sequence;

    constructor(options: AudioControlOptions) {
        options = e5.object.merge({

        }, options);

        this._element = document.createElement("div");
        this._element.className = "audio-control";
        this._element.innerHTML = `
        <div class="audio-control__content">
            <div class="audio-control__center">
                <div class="audio-control__corner audio-control__corner--left"></div>
                <div class="audio-control__corner audio-control__corner--right"></div>
            </div>
            <div class="audio-control__menu-bar"></div>
        </div>
        `;

        this._sequence = options.sequence;

        let prev = this.add({
            icon: "fas fa-backward-step",
            active: false,
            disabled: true,
            onClick: () => {
                this._sequence.prev(true);
            }
        });

        let playToggle = this.add({
            icon: "fas fa-play",
            iconActive: "fas fa-pause",
            active: false,
            disabled: true,
            onClick: () => {
                this._sequence.toggle();
            }
        });

        let next = this.add({
            icon: "fas fa-forward-step",
            active: false,
            disabled: true,
            onClick: () => {
                this._sequence.next(true);
            }
        });

        let stop = this.add({
            icon: "fas fa-stop",
            active: false,
            disabled: true,
            onClick: () => {
                this._sequence.stop();
            }
        });

        this._sequence.onTime.add(() => {
            updateStopState();
        });

        this._sequence.onChangeState.add(() => {
            updateStopState();
            playToggle.active = this._sequence.state === "playing";
        });

        let updateStopState = () => {

            let disabled = false;
            if (this._sequence.items.length === 0) {
                disabled = true;
            } else if (this._sequence.time === 0
                && this._sequence.state === "paused") {
                disabled = true;
            }
            stop.disabled = disabled;
        };

        this._sequence.onChangeItems.add(() => {
            playToggle.disabled = this._sequence.items.length === 0;
            prev.disabled = this._sequence.items.length <= 1;
            next.disabled = this._sequence.items.length <= 1;
            updateStopState();
        });

        options.container.appendChild(this._element);
    }

    private add(options: AudioControlButtonOptions): AudioControlButton {
        const btn = new AudioControlButton(
            this._element.querySelector(".audio-control__center"),
            options);
        return btn;
    }
}

interface AudioControlButtonOptions {
    icon: string;
    iconActive?: string;
    iconDisabled?: string;
    active?: boolean;
    disabled?: boolean;
    onClick?: (button: AudioControlButton) => void;
}

class AudioControlButton {

    public onClick = e5.Signal.create<[AudioControlButton]>();

    private _element: HTMLButtonElement;

    private _icon: string = "";
    private _iconActive: string = "";
    private _iconDisabled: string = "";

    constructor(container: HTMLElement, options: AudioControlButtonOptions) {
        options = e5.object.merge({
            active: false
        }, options);

        this._icon = options.icon;
        this._iconActive = options.iconActive;
        this._iconDisabled = options.iconDisabled;

        this._element = document.createElement("button");
        this._element.className = "audio-control__button";
        this._element.innerHTML = `
        <div class="audio-control__button-icon"></div>
        `;

        this.active = options.active;
        this.disabled = options.disabled;
        this.updateIcon();

        this._element.addEventListener("click", () => {
            this.onClick.dispatch(this);
        });

        if (typeof options.onClick === "function") {
            this.onClick.add(options.onClick);
        }

        container.appendChild(this._element);
    }

    public get active(): boolean {
        return this._element.classList.contains("audio-control__button--active");
    }

    public set active(value: boolean) {
        if (this.active === value) {
            return;
        }
        this._element.classList.toggle("audio-control__button--active", value);
        this.updateIcon();
    }

    public get disabled(): boolean {
        return this._element.disabled;
    }

    public set disabled(value: boolean) {
        if (this._element.disabled === value) {
            return;
        }
        this._element.disabled = value;
        this.updateIcon();
    }

    private updateIcon(): void {
        let icon = this._icon;
        if (this.disabled
            && this._iconDisabled) {
            icon = this._iconDisabled;
        }
        else if (this.active
            && this._iconActive) {
            icon = this._iconActive;
        }

        let cls = "audio-control__button-icon";
        let e = this._element.querySelector("." + cls);
        e.className = cls + " " + icon;
    }
}